import React from 'react';
import { format, isToday, isTomorrow, isAfter } from 'date-fns';
import { STATUSES } from '../../data/mockData';

const fallbackType = { label: 'Appointment', color: '#6B7280' };
const fallbackStatus = { label: 'Unknown', color: '#6B7280' };

export default function UpcomingList({ appointments, onSelectAppointment, typesMap = {} }) {
  const upcoming = appointments
    .filter(a => isAfter(a.start, new Date()) || isToday(a.start))
    .filter(a => a.status !== 'cancelled' && a.status !== 'completed' && a.status !== 'no_show')
    .sort((a, b) => a.start - b.start)
    .slice(0, 8);

  const dayLabel = (date) => {
    if (isToday(date)) return 'TODAY';
    if (isTomorrow(date)) return 'TOMORROW';
    return format(date, 'EEE, MMM d').toUpperCase();
  };

  return (
    <div className="hidden xl:block w-[296px] bg-secondary border-l border-theme p-5 overflow-y-auto flex-shrink-0">
      <h3 className="text-[10px] font-bold uppercase tracking-[1.2px] text-muted-c mb-4 pl-0.5">
        Upcoming
      </h3>
      <div className="flex flex-col gap-1.5">
        {upcoming.map(appt => {
          const type = typesMap[appt.type] || fallbackType;
          const status = STATUSES[appt.status] || fallbackStatus;
          return (
            <button
              key={appt.id}
              onClick={() => onSelectAppointment(appt)}
              className="flex gap-3 p-3 rounded-[10px] bg-tertiary border border-theme text-primary-c cursor-pointer transition-all hover:bg-hover-surface hover:translate-x-0.5 hover:shadow-sm text-left font-[inherit] w-full"
            >
              <div className="w-[3px] rounded-sm flex-shrink-0 self-stretch" style={{ background: type.color }} />
              <div className="flex-1 min-w-0">
                <div className="flex justify-between items-center">
                  <span className="text-[10px] font-bold text-accent-light tracking-wider">{dayLabel(appt.start)}</span>
                  <span className="text-[11px] text-muted-c font-medium">{format(appt.start, 'h:mm a')}</span>
                </div>
                <div className="text-[13px] font-bold mt-1 mb-0.5 tracking-tight">{appt.client.name}</div>
                <div className="flex justify-between text-[11px] text-muted-c">
                  <span>{type.label}</span>
                  <span className="font-semibold" style={{ color: status.color }}>{status.label}</span>
                </div>
                {appt.is_collaborator && appt.owning_org && (
                  <div className="text-[10px] text-[#223368] font-medium mt-0.5">
                    via {appt.owning_org.name}
                  </div>
                )}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
